import {Component} from 'react'
import {toastr} from 'react-redux-toastr'
import {Badge} from 'reactstrap'
import connect from 'react-redux/es/connect/connect'
import { format } from 'date-fns'
import PropTypes from 'prop-types'

import api from '../../../../../api.js'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import {redirectToAccessDenied} from '../../../Errors/actions.js'
import OfferForm from '../../../../components/Forms/OfferForm/OfferForm.jsx'
import SubmitButton from '../../../../components/Forms/OfferForm/SubmitButton.jsx'
import {isAdmin} from '../../../../../shared/services/userService.js'
import OfferLayout from '../OfferLayout/OfferLayout.jsx'

import './OfferDetailsEdit.scss'

class OfferDetailsEdit extends Component {
  static propTypes = {
    goToOffer: PropTypes.func.isRequired,
    withLayout: PropTypes.bool,
  }

  static defaultProps = {
    withLayout: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: props.loading || false
    }
  }

  submit = (data) => {
    this.setState({loading: true})
    const offer = this.props.flattenOffer(data.offer)
    return api.offers.edit({
      ...offer,
    })
  }

  onFormSuccess = async (response) => {
    await this.props.refresh({...response.data, universe: 1})
    toastr.success('Votre annonce a bien été modifiée.')
    this.setState({loading: false})
  }

  changePublished = async (published) => {
    const offer = {published}
    if (true === offer.published) {
      offer.publication_date = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
      offer.filled_date = null
      offer.filled = false
    }

    await this.editOffer(offer)
  }

  changeFilled = async (filled) => {
    const offer = {filled}
    if (filled) {
      offer.filled_date = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
    }

    await this.editOffer(offer)
  }

  changeLocked = async (locked) => {
    await this.editOffer({locked})
  }

  editOffer = async (offer) => {
    try {
      this.setState({loading: true})
      const response = await api.offers.edit({
        ...offer,
        offer: this.props.offer?.id
      })
      await this.props.refresh(response.data)
    } catch (e) {
      console.warn(e)
      if (e.data) {
        toastr.error(e.data.message)
      }
    } finally {
      this.setState({loading: false})
    }
  }

  render() {
    if (!this.props.isAdmin) {
      this.props.redirectToAccessDenied()
      return null
    }

    const {offer} = this.props
    const smsSent = offer?.sms_ticket?.nb_sendings ?? 0
    const nbApplications = offer?.nbOfferAnswer ?? 0

    const offerDetails = (
      <div className="offer-details-edit p-2 p-md-5">
        {offer?.id ?
          <div className="badges mt-2 mb-4 d-flex align-items-center flex-wrap">
            <Badge color="info">{offer?.published ? '' : 'Non '}publiée</Badge>
            <Badge color="info">{offer?.filled ? '' : 'Non '}pourvue</Badge>
            <Badge color="info">{offer?.locked ? '' : 'Non '}verrouillée</Badge>
            {smsSent ? <Badge color="info">{smsSent} sms</Badge> : ''}
            {nbApplications ? <Badge color="info">{nbApplications} candidatures</Badge> : ''}
          </div> : ''
        }
        <OfferForm
          enableReinitialize={true}
          initialValues={{
            offer: {
              ...offer,
              logo: offer?.logo?.id ?? null,
              manager: offer?.manager?.id ?? null,
              sub_universes: offer?.sub_universes?.length ? offer.sub_universes : []
            }
          }}
          onSubmit={this.submit}
          onSubmitSuccess={this.onFormSuccess}
        />
        <Loader visible={this.props.loading || this.state.loading}/>

        <div className="action-buttons d-flex flex-wrap align-items-center justify-content-end my-3">
          <button className="btn btn-primary my-1" onClick={() => this.changeFilled(!offer.filled)}>
            Passer en {offer.filled ? 'non ' : ''}pourvue
          </button>
          <button className="btn btn-primary my-1" onClick={() => this.changePublished(!offer.published)}>
            {offer.published ? 'Dépublier' : 'Publier'}
          </button>
          <button className="btn btn-primary my-1" onClick={() => this.changeLocked(!offer.locked)}>
            {offer.locked ? 'Déverrouiller' : 'Verrouiller'}
          </button>
          <button className="btn btn-secondary my-1" onClick={() => this.props.goToOffer(offer)}>
            Voir l'annonce
          </button>
          <SubmitButton className="btn btn-primary my-1">Enregistrer</SubmitButton>
        </div>
      </div>
    )

    if (this.props.withLayout) {
      return <OfferLayout>{offerDetails}</OfferLayout>
    }

    return offerDetails
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  }),
  (dispatch) => ({
    redirectToAccessDenied: () => dispatch(redirectToAccessDenied()),
  })
)(OfferDetailsEdit)
